export default "__VITE_ASSET__Cg0lPw_o__"